import { catchError, map, tap } from 'rxjs/operators';
import { ApiService } from '@api/services/api/api.service';
import { AuthService } from '@services/auth/auth.service';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserCustomerDTO, UserCustomerUpdateDTO } from '@api/models';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  /**
   * subject per gestire lo stato del customer
   */
  private customer$: BehaviorSubject<UserCustomerDTO> =
    new BehaviorSubject<UserCustomerDTO>(null);

  constructor(
    private authService: AuthService,
    private apiService: ApiService
  ) {}

  /**
   * carica il customer legato all'utente loggato
   */
  loadCustomer(): Observable<boolean> {
    return this.apiService
      .getOnboardingCustomer({ pathParams: { userId: this.getUserId() } })
      .pipe(
        catchError(() => of(null)),
        tap(res => this.setCustomer(res)),
        map(() => true)
      );
  }

  /**
   * stabilisce se il customer è registrato correttamente
   */
  isRegistered(): boolean {
    return !!this.getCustomer();
  }

  /**
   * stabilisce se il customer registrato è incompleto
   */
  isIncomplete(): boolean {
    const customer = this.getCustomer();

    return (
      !customer ||
      !customer.firstName ||
      !customer.lastName ||
      !customer.taxNumber
    );
  }

  /**
   * restituisce i dati attuali del customer
   */
  getCustomer(): UserCustomerDTO {
    return this.customer$.getValue();
  }

  /**
   * restituisce osservabile che si aggiorna ogni volta che viene caricato il customer
   */
  getCustomerWhenChange(): Observable<UserCustomerDTO> {
    return this.customer$.asObservable();
  }

  /**
   * aggiorna i dati del customer
   */
  updateCustomer(update: Partial<UserCustomerUpdateDTO>): Observable<any> {
    return this.apiService.putOnboardingCustomer({
      pathParams: { userId: this.getUserId() },
      body: {
        ...update,
        userId: this.getUserId()
      }
    });
  }

  /**
   * restituisce l'user id dell'utente loggato
   */
  private getUserId(): string {
    return this.authService.getAuthUser().userId;
  }

  /**
   * aggiorna il subject del customer
   */
  private setCustomer(customer: UserCustomerDTO): void {
    this.customer$.next(!!customer ? customer : {});
  }
}
